import { useTheme } from 'antd-style'
import { isNil } from 'lodash'

import { pick } from '@eastcoal/common/utils/object'

import { TradeSessionStatus } from '../../../../../../enums/TradeSessionStatus'
import { useAuctionDetailStore } from '../../../Store/hooks/useStore'

export const StartOrLimitPriceRender = () => {
  const {
    detailData: { priceUnit },
    statusInfo,
    priceInfo: { value: priceValue }
  } = useAuctionDetailStore(state =>
    pick(state, ['detailData', 'isBidOnlyOnce', 'statusInfo', 'priceInfo'])
  )
  const theme = useTheme()
  // 出价前不显示；出价后，如果未设置价格显示*号
  return (statusInfo?.status ?? 0) <= TradeSessionStatus.WAIT_BID_START ? (
    '***'
  ) : isNil(priceValue) ? (
    '无'
  ) : (
    <span>
      <span style={{ color: theme.colorErrorText }}>{priceValue}</span>
      <span>{priceUnit}</span>
    </span>
  )
}
